import React from 'react';
import AddEditRoleForm from 'ui-component/AddEditRoleForm';

function AddRole() {
  return (
    <div>
      <AddEditRoleForm title="Add Role" />
    </div>
  );
}

export default AddRole;
